document.addEventListener('DOMContentLoaded', () => {
	const counters = document.querySelectorAll('.counters__item-counter');
	let started = false;

	function startCounting(entry) {
	  if (entry.isIntersecting && !started) {
		started = true;
		counters.forEach(counter => {
		  const target = parseInt(counter.innerText.replace(/\D/g, ''), 10);
		  const duration = 4000; // Czas trwania animacji w milisekundach
		  const steps = 50; // Ilość kroków animacji
		  let current = 0;
		  const increment = target / steps;
		  const timer = setInterval(() => {
			current += increment;
			if (current >= target) {
			  clearInterval(timer);
			  counter.innerText = target;
			} else {
			  counter.innerText = Math.round(current);
			}
		  }, duration / steps);
		});
	  }
	}

	const observer = new IntersectionObserver((entries) => {
	  entries.forEach(startCounting);
	}, { threshold: 0.5 });

	const counterSection = document.querySelector('.counters__items');
	if (counterSection) {
	  observer.observe(counterSection);
	}
  });
